import {
  Apartment,
  AttachFile,
  FolderOpenOutlined,
  FolderOutlined,
  Inventory2Outlined,
  WorkOutline,
} from '@mui/icons-material';
import { JSX } from 'react';

// Per-entity icon color tint — reinforces the hierarchy gradient
// (program → project → folder) at a glance. To roll back, swap all of
// these for `{ color: 'text.secondary' }`.
const COLOR_PROGRAM = '#1F4D83'; // Tyto Deep Blue (matches TAR section accent)
const COLOR_PROJECT = '#0092CB'; // Tyto cyan
const COLOR_NEUTRAL = 'text.secondary';

export const getEntityIcon = (
  entityType: string | undefined,
  expanded: boolean = false,
): JSX.Element => {
  switch (entityType) {
    case 'program':
      return <Apartment fontSize="small" sx={{ color: COLOR_PROGRAM }} />;
    case 'project':
      return <WorkOutline fontSize="small" sx={{ color: COLOR_PROJECT }} />;
    case 'library_directory':
      return expanded ? (
        <FolderOpenOutlined fontSize="small" sx={{ color: COLOR_NEUTRAL }} />
      ) : (
        <FolderOutlined fontSize="small" sx={{ color: COLOR_NEUTRAL }} />
      );
    case 'deliverable':
      return <Inventory2Outlined fontSize="small" sx={{ color: COLOR_NEUTRAL }} />;
    case 'attachment':
      return <AttachFile fontSize="small" sx={{ color: COLOR_NEUTRAL }} />;
    default:
      return <FolderOutlined fontSize="small" sx={{ color: COLOR_NEUTRAL }} />;
  }
};
